import { HTTP_CLIENT } from '@common/clients/http/http.client.interface';
import { AUTH_SERVICE } from '@common/services/auth/auth.service.interface';
import { LOG_SERVICE } from '@common/services/log/log.service.interface';
import { STORAGE_SERVICE } from '@common/services/storage/storage.service.interface';
import HttpClient from '@input-web/clients/http/http.client';
import AuthService from '@input-web/services/auth/auth.service';
import LogService from '@input-web/services/log/log.service';
import StorageService from '@input-web/services/storage/storage.service';
import { container } from 'tsyringe';

container.registerInstance(LOG_SERVICE, new LogService());

container.registerInstance(AUTH_SERVICE, new AuthService());

container.registerInstance(HTTP_CLIENT, new HttpClient());

container.registerInstance(STORAGE_SERVICE, new StorageService());
